const defaultCountryDetails = (state = null, action) => {
  if (action.type === "SET_DEFAULT_COUNTRY_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_DEFAULT_COUNTRY_DETAILS": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default defaultCountryDetails;
